module.exports = __webpack_public_path__ + "static/media/InstagramLogo.902e17a6.svg";